import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import audiencesCRUDActions from '@mm/state/actions/AudiencesCRUDActions';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import {
  hideSlideoutMenu,
  showSlideoutMenu,
} from '@mm/state/actions/viewActions';
import { MyLeadsFiltersSlideoutProps } from '../../../../components/SlideoutMenu/menus/MyLeadsFiltersSlideout/MyLeadsFiltersSlideout';

export const useCreateNewAudience = () => {
  const activeChatbotId = useSelector(activeChatbotIdSelector);

  const dispatch: Dispatch<StoreState> = useDispatch();

  const createAudience = (
    entity?: Partial<AudiencesModel>,
    hiddenAudience?: boolean,
  ) => {
    const audience = entity
      ? entity
      : { filterParams: {}, deleteContacts: false, hidden: hiddenAudience };
    return dispatch(audiencesCRUDActions.create(audience, activeChatbotId));
  };

  const openAudienceSlideoutMenu = useCallback(
    (props: MyLeadsFiltersSlideoutProps) => {
      dispatch(showSlideoutMenu('myLeadsFilters', props));
    },
    [activeChatbotId],
  );

  const hideAudienceSlideoutMenu = useCallback(() => {
    dispatch(hideSlideoutMenu());
  }, [activeChatbotId]);

  const createOrEditAudienceAndOpenMenu = async (
    props: MyLeadsFiltersSlideoutProps & { hiddenAudience?: boolean },
  ): Promise<number | undefined> => {
    const { activeAudience, hiddenAudience, ...rest } = props;

    const audience = activeAudience
      ? activeAudience
      : await createAudience(undefined, hiddenAudience);
    openAudienceSlideoutMenu({ activeAudience: audience, ...rest });

    return audience?.id;
  };

  return {
    createAudience,
    hideAudienceSlideoutMenu,
    createOrEditAudienceAndOpenMenu,
  };
};
